import React from 'react';
import { INDUSTRIES, INTEGRATION_LOGOS } from '../mock';
import { Building2, Home, Plane, Sparkles as SparklesIcon, Briefcase, Scissors, Wrench, HeartPulse, GraduationCap, UtensilsCrossed, ChefHat, ShoppingBag } from 'lucide-react';

const INDUSTRY_ICONS = [Building2, Home, Plane, SparklesIcon, Briefcase, Scissors, Wrench, HeartPulse, GraduationCap, UtensilsCrossed, ChefHat, ShoppingBag];

export default function IndustriesSection() {
  const doubled = [...INDUSTRIES, ...INDUSTRIES];
  return (
    <section className="py-20 bg-neutral-50 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-center mb-12 fade-in">
        <h2 className="text-4xl md:text-5xl font-black text-black">
          Xxpand Helps You Automate Your <span className="text-[#22c55e]">Business</span>
        </h2>
        <p className="text-neutral-600 mt-3 max-w-2xl mx-auto">Trusted across diverse industries for real, measurable growth.</p>
      </div>

      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-neutral-50 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-neutral-50 to-transparent z-10 pointer-events-none" />
        <div className="marquee-track marquee-track-slow">
          {doubled.map((name, i) => {
            const Icon = INDUSTRY_ICONS[i % INDUSTRY_ICONS.length];
            return (
              <div key={`${name}-${i}`} className="mx-4 flex-shrink-0">
                <div className="w-[220px] h-[140px] rounded-2xl bg-white border border-neutral-200 flex flex-col items-center justify-center gap-3 hover:border-[#22c55e] hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
                  <div className="w-12 h-12 rounded-xl bg-[#dcfce7] flex items-center justify-center">
                    <Icon className="w-6 h-6 text-black" strokeWidth={2} />
                  </div>
                  <div className="font-bold text-sm text-black text-center px-3">{name}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Integrations */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-24 text-center fade-in">
        <h3 className="text-3xl md:text-4xl font-black text-black mb-4">Easily Connect With The Apps You Love</h3>
        <p className="text-neutral-600 max-w-2xl mx-auto mb-10">Seamlessly integrate with 1000+ tools your team already relies on.</p>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {INTEGRATION_LOGOS.map((logo) => (
            <div key={logo} className="h-20 rounded-2xl bg-white border border-neutral-200 flex items-center justify-center font-bold text-neutral-500 hover:border-[#22c55e] hover:text-black hover:shadow-md transition-all duration-300">
              {logo}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
